import React from 'react';
import {
  asSingleSelection,
  createTagOptionInput,
} from '../../../../../../components/Builder/EntitySelection/utils';
import EntitySelection from '../../../../../../components/Builder/EntitySelection';
import { useAppSelector } from '../../../../../../redux/hooks';
import { activeSchemaIdSelector } from '../../../../../../redux/selectors/builder';
import {
  ICohortFieldsFragment,
  TagOption,
} from '../../../../../../utils/apollo/graphqlSchema';
import { ISelectedEntity } from '../../../../../../components/Builder/EntitySelection/types';
import { assertCondition } from '../../../../../../utils/types';

interface IProps {
  value: ICohortFieldsFragment | null;
  placeholder: string;
  onChange: (namedCohort: ICohortFieldsFragment | null) => void;
  hasError?: boolean;
}

const tags = [
  createTagOptionInput(TagOption.SimpleCohort),
  createTagOptionInput(TagOption.CompoundCohort),
];

const SignificanceSegmentCriteriaField = ({
  value,
  placeholder,
  onChange,
  hasError,
}: IProps) => {
  const activeSchemaId = useAppSelector(activeSchemaIdSelector);

  const handleChange = (entity: ISelectedEntity) => {
    assertCondition(
      entity.__typename === 'RetentionCohort' ||
        entity.__typename === 'FunnelCohort' ||
        entity.__typename === 'PerformedCohort' ||
        entity.__typename === 'CompoundCohort' ||
        entity.__typename === 'ExpressionCohort' ||
        entity.__typename === 'MeasureCohort',
    );
    onChange(entity);
  };

  const handleRemove = () => {
    onChange(null);
  };

  return (
    <EntitySelection
      schemaId={activeSchemaId}
      selectedEntities={asSingleSelection(value)}
      tags={tags}
      onRemoveEntity={handleRemove}
      onSelectEntity={handleChange}
      placeholder={placeholder}
      isError={hasError}
    />
  );
};

export default SignificanceSegmentCriteriaField;
